import { Injectable } from "@angular/core";
import { BleClient, BleDevice, BleService, ScanResult } from '@capacitor-community/bluetooth-le';
import { ModalController } from "@ionic/angular";
import { BehaviorSubject } from "rxjs";
import { BadgeModal } from "../_modals/badge/badge.modal";

export const namePrefix = 'wire';
export const DEFAULT_TIMEOUT = 5000;
export const CHARACTERISTIC_UUID = "fa1f3136-06f9-4216-b9ca-6702cf990627"

export interface BleConnection {
    device : BleDevice,
    services : BleService[]
}

@Injectable()
export class BadgeService {
    
    private availableSub = new BehaviorSubject<BleDevice[]>([]);
    public available$ = this.availableSub.asObservable();

    private connectedSub = new BehaviorSubject<BleConnection | null>(null);
    public connected$ = this.connectedSub.asObservable();

    get availableDevices() {
        // return [{
        //     "deviceId": "2C1C8A19-9C8D-1764-BF35-4ABCACB30472",
        //     "name": "wire badge - 001"
        // },
        // {
        //     "deviceId": "2C1C8A19-9C8D-1764-BF35-4ABCACB30472",
        //     "name": "wire badge - 002"
        // },
        // {
        //     "deviceId": "2C1C8A19-9C8D-1764-BF35-4ABCACB30472",
        //     "name": "wire badge - 003"
        // },
        // {
        //     "deviceId": "2C1C8A19-9C8D-1764-BF35-4ABCACB30472",
        //     "name": "wire badge - 004"
        // },
        // {
        //     "deviceId": "2C1C8A19-9C8D-1764-BF35-4ABCACB30472",
        //     "name": "wire badge - 005"
        // }]
        return this.availableSub.value
    }
    get connectedDevice() : BleDevice | null {
    //     return null
    //    return  {
    //         "deviceId": "2C1C8A19-9C8D-1764-BF35-4ABCACB30472",
    //         "name": "wire badge - 001"
    //     }
        return this.connectedSub.value?.device
    }
    get connectedServices() {
        return this.connectedSub.value?.services
    }

    enabled = false;
    scanning = false;

    constructor(
        private modalC : ModalController
    ) {}

    async init() {
        try {
            await BleClient.initialize();
            if (!await BleClient.isEnabled()) await BleClient.requestEnable();
            this.enabled = await BleClient.isEnabled();
            console.log('BLE Enabled?:', this.enabled);
            return this.enabled
        } catch (error) {
            console.log('BLE Connection Error:', error);
        }
    }

    async startScan() {
        try {
            this.scanning = true;

            if (!await BleClient.isEnabled()) await BleClient.requestEnable();

            this.availableSub.next([]);
            let availableDevices: BleDevice[] = [];

            await BleClient.requestLEScan({
                namePrefix
            },
            (result) => {
                if (!availableDevices.find(device => device.deviceId === result.device.deviceId)){
                    availableDevices.push(result.device);
                    this.availableSub.next(availableDevices);
                }
            });
            
            setTimeout(async () => {
                await BleClient.stopLEScan();
                console.log('Stopped scanning');
                this.scanning = false;
            }, DEFAULT_TIMEOUT);
        }
        catch (error) {
            console.log('Error starting scan', error.message);
            this.scanning = false;
        }
    }

    async stopScan() {
        await BleClient.stopLEScan();
        console.log('Stopped scanning');
    }

    async connectToDevice(device: BleDevice) {
        try {
            await BleClient.connect(device.deviceId, (deviceId) => this.onDisconnect(deviceId));
            const connection : BleConnection = {
                device,
                services : await BleClient.getServices(device.deviceId)
            }
            this.connectedSub.next(connection);
            console.log('CONNECTION:', connection);
            return connection
        }
        catch (error) {
            console.log('Error connecting to device', device, error);
        }
    }

    async disconnect(deviceId?: string) {
        if (!deviceId) deviceId = this.connectedDevice?.deviceId;
        await BleClient.disconnect(deviceId);
        this.onDisconnect(deviceId);
    }

    onDisconnect(deviceId: string) {
        console.log('Device disconnected', deviceId);
        this.connectedSub.next(null);
        this.openModal();
    }

    async openModal() {
        let modal = await this.modalC.create({
            component: BadgeModal,
            cssClass: 'main-modal',
            handle: true,
            canDismiss: true,
            initialBreakpoint: 1, // this.myPowerLevel && this.myPowerLevel >= 50 ? 0.9 : 0.6,
            breakpoints : [1],
            componentProps: {

            }
        });

        modal.onDidDismiss().then((res : any) => {
            if (res && res.data){
                console.log('Modal data:', res.data);
            }
        })
        return await modal.present(); 
    }

}